import { mediaQueries } from '@centivo/react-components'
import styled, { css } from 'styled-components'

export const NavSlice = styled.nav`
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  padding: 2rem 2.5rem 2rem 2.5rem;

  z-index: 10;
  width: 100%;
  max-width: 1440px;
  margin: auto;
  align-items: center;

  & > a {
    align-items: center;
    display: flex;
    height: 2rem;
    font-weight: 700;
  }

  @media ${mediaQueries.mobile} {
    padding: 1.3rem 1rem 1.3rem 1.3rem;
  }

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-eligibility':
        return css`
          @media ${theme.mediaQueries.mobile} {
            & > a {
              margin: auto;
            }
          }
        `
      default:
        return {}
    }
  }}
`
